/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";

export const SenderLastNameColumnFormatter = (cellContent, row, rowIndex) => {
  const { senderLastName } = row;

  return (
    <>
      <div className="d-flex align-items-center text-capitalize">
        {senderLastName ? senderLastName : `-`}
      </div>
      <> </>
    </>
  );
};
